import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  InputBase,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterPanel from "./FilterPanel";
import TableHeaderDropdown from "./TableHeaderDropdown";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DownloadIcon from "@mui/icons-material/Download";
import { useSelectTagContext } from "../../context/SelectTagContext";
import { ClearIcon } from "@mui/x-date-pickers";

function SearchboxHeader({
  type,
  onSearch,
  data,
  latestUpdateTime,
  items,
  page,
  onApplyFilters,
  searchPermission = true,
  onSelectedItem,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState("");
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const {
    appliedFilters,
    setAppliedFilters,
    setSelectedFilters,
    setCancelFilters,
  } = useSelectTagContext();

  useEffect(() => {
    setSelectedItem(page);
  }, [page]);

  const styles = {
    headerBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      // mb: 1,
      p: 1,
    },
    titleTypography: {
      display: "flex",
      alignItems: "center",
      fontSize: "13px",
      fontWeight: 600,
      // cursor: "pointer",
    },
    subtitleTypography: {
      color: "#9F9F9F",
      fontSize: "10px",
    },
    searchBox: {
      alignItems: "center",
      display: "flex",
      padding: "10px",
      justifyContent: "space-between",
      borderBottom: "1px solid gray",
    },
    inputBase: {
      borderRadius: "20px",
      width: "85%",
      height: "32px",
      border: "1px solid #9F9F9F",
      mr: 2,
    },
    searchIcon: {
      color: "#9F9F9F",
      ml: "3px",
      mr: "-3px",
      width: "20px",
      height: "20px",
    },
    filterIcon: {
      color: "white",
      borderRadius: "50%",
      backgroundColor: "#0077B6",
      fontSize: "30px",
      padding: "5px",
      marginRight: "5px",
      cursor: "pointer",
    },
    keyDownIcon: {
      fontSize: "17px",
      ml: 0.2,
      mr: 1,
    },
  };

  const handleFilterClick = () => {
    setFilterPanelOpen(!filterPanelOpen);
  };

  const handleFilterClose = () => {
    setFilterPanelOpen(false);
  };

  const handleSearchInputChange = (event) => {
    onSearch(event.target.value);
  };

  const handleMenuItemClick = (selectedItem) => {
    setSelectedItem(selectedItem);
    handleClose();
    onSelectedItem(selectedItem);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDownload = () => {
    console.log("download");
  };

  const handleClearFilterText = () => {
    setAppliedFilters(() => ({
      partID: "",
      partPrediction: "",
      partTimestamp: "",
      productID: "",
      productPrediction: "",
      productTimestamp: "",
      fromTimestamp: "",
      toTimestamp: "",
    }));
    setSelectedFilters(() => ({
      partID: "",
      productID: "",
      prediction: "",
      timestamp: "",
      factorsName: "",
      fromTimestamp: "",
      toTimestamp: "",
    }));
    setCancelFilters(true)
  };

  return (
    <>
      <Box sx={styles.headerBox}>
        <Box sx={{ flexDirection: "column" }}>
          <Typography
            sx={styles.titleTypography}
            //  onClick={handleClick}
          >
            {selectedItem}
            {/* <KeyboardArrowDownIcon sx={styles.keyDownIcon} /> */}
          </Typography>
          <TableHeaderDropdown
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorEl={anchorEl}
            items={items}
            handleMenuItemClick={handleMenuItemClick}
          />
          <Typography sx={styles.subtitleTypography}>
            {/* {data?.length} Parts &bull; Updated {latestUpdateTime} */}
            {/* {page === "By Parts" ? ( */}
              <span>
                {appliedFilters.fromTimestamp != "" &&
                  appliedFilters.fromTimestamp != null &&
                  appliedFilters.toTimestamp != "Invalid Date" && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "12px",
                          marginRight: "10px",
                          fontWeight: "500",
                        }}
                      >
                        From {appliedFilters.fromTimestamp} {" To "}
                        {appliedFilters.toTimestamp}
                      </Typography>
                      <IconButton
                        onClick={handleClearFilterText}
                        sx={{
                          backgroundColor: "white",
                          cursor: "pointer",
                          height: "25px",
                          width: "25px",
                          border: "1px solid #e4e4e4",
                          borderRadius: "20px",
                          marginRight: "10px",
                          fontSize: "12px",
                          "&:hover": {
                            backgroundColor: "#e4e4e4",
                            color: "white",
                          },
                        }}
                      >
                        <ClearIcon
                          size="small"
                          sx={{
                            fontSize: "18px",
                          }}
                        />
                      </IconButton>
                    </span>
                  )}
              </span>
          </Typography>
        </Box>
        {/* <IconButton
          variant="contained"
          sx={{
            backgroundColor: "#0077B6",
            padding: "4px",
            marginRight: "5px",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0077B6",
              color: "white",
            },
          }}
          onClick={onDownload}
        >
          <DownloadIcon
            sx={{
              fontSize: "20px",
            }}
          />
        </IconButton> */}
      </Box>
      {searchPermission && (
        <Box sx={styles.searchBox}>
          <InputBase
            type="text"
            placeholder="Search..."
            onChange={handleSearchInputChange}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={styles.searchIcon} />
              </InputAdornment>
            }
            sx={styles.inputBase}
          />
          <FilterAltIcon
            style={styles.filterIcon}
            onClick={handleFilterClick}
          />
          {filterPanelOpen && (
            <FilterPanel
              handleClose={handleFilterClose}
              open={filterPanelOpen}
              page={`quality-${page}`}
              // documentClientData={documentClientData}
              // documentType={documentType}
              onApplyFilters={onApplyFilters}
            />
          )}
        </Box>
      )}
    </>
  );
}

export default SearchboxHeader;
